// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M9.48063 2.5H1V21H23V5H11.4806L9.48063 2.5ZM12.6573 11.9988L11.1914 10.4685L12.6356 9.08496L16.3848 12.9988L12.6356 16.9127L11.1914 15.5293L12.6573 13.9988H8V11.9988H12.6573Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-folder-move-filled')
export default class FolderMoveFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'folder-move-filled',
    }
  }
}
